export const STORAGE = {
  // prefix — full key is `activeServiceName:<userId>`
  activeServiceName: 'activeServiceName:',
  filters: 'filtersHistory',
  theme: 'theme',
};
